(function() {
  'use strict';

  var _cf = document.querySelector('[data-finish-block]');
  if (!_cf) return;

  var BLOCK_ID = _cf.dataset.finishBlock;
  var SECTION_ID = _cf.dataset.sectionId;
  var FEE_VARIANT_ID = _cf.dataset.feeVariantId;
  // Hardcoded: Polished = free, Hammered/Matte/Brushed = $50
  var FEE_CENTS = 5000;
  var FEE_FORMATTED = '$50';

  // ============================================================
  // IMAGE MAP: finish -> color -> data attribute key
  // Data attributes on container hold CDN URLs for each combo
  // Named: data-{finish}-{color} e.g. data-hammered-yellow-gold
  // ============================================================
  var FINISHES = ['hammered', 'matte', 'brushed', 'polished'];
  var COLOR_MAP = {
    'Yellow Gold': 'yellow-gold',
    'White Gold': 'white-gold',
    'Rose Gold': 'rose-gold'
  };

  function getImageUrl(finish, colorKey) {
    var attrName = finish.toLowerCase() + '-' + colorKey;
    // Convert to camelCase for dataset access
    var camel = attrName.replace(/-([a-z])/g, function(m, c) { return c.toUpperCase(); });
    return _cf.dataset[camel] || '';
  }

  // ============================================================
  // SHARED: Find the visible price span (handles sale + regular)
  // ============================================================
  function findPriceSpan(container) {
    if (!container) return null;
    var candidates = container.querySelectorAll('.price-item');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest('s')) continue;
      if (el.closest('.visually-hidden')) continue;
      if (el.closest('.d-none')) continue;
      return el;
    }
    // Fallback
    return container.querySelector('.price-item--regular, .price-item--last, .price__item, .price__number');
  }

  function initFinishBlock() {
    var container = _cf;
    if (!container) return;

    var productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                      container.closest('form[action*="/cart/add"]') ||
                      container.closest('.product__details')?.querySelector('form[action*="/cart/add"]') ||
                      document.querySelector('form[action*="/cart/add"]:not(.installment)');

    if (!productForm) return;

    // Elements
    var radios = container.querySelectorAll('.finish-block__radio');
    var feeNotice = container.querySelector('.finish-block__fee-notice');
    var feeText = container.querySelector('.finish-block__fee-text');
    var feeAmountEl = container.querySelector('.finish-block__fee-amount');
    var selectedFinishDisplay = container.querySelector('.finish-block__selected-finish');

    // State
    var currentFinish = 'Polished'; // Polished is default/checked
    var currentColor = 'Yellow Gold'; // Will be read from DOM

    // Price container - use stable outer container that survives section re-rendering
    var priceContainer = SECTION_ID
      ? document.getElementById('productPrice-' + SECTION_ID)
      : null;
    if (!priceContainer) {
      priceContainer = document.querySelector('[id^="productPrice-"]') ||
                       document.querySelector('.product__price, .price, [data-price]');
    }

    // ============================================================
    // READ SELECTED COLOR
    // Primary: read the Color display text (always updated by variant picker)
    // Fallback: checked radio inputs
    // ============================================================
    function getSelectedColor() {
      // 1. Read from the Color option name display element (most reliable)
      var colorDisplay = document.querySelector('.js-variant-radio-option-name[data-option-name="Color"]');
      if (colorDisplay) {
        var text = colorDisplay.textContent.trim();
        if (text && text in COLOR_MAP) return text;
      }
      // Also check dropdown display
      var colorSelectDisplay = document.querySelector('.js-variant-select-option-name[data-option-name="Color"]');
      if (colorSelectDisplay) {
        var text2 = colorSelectDisplay.textContent.trim();
        if (text2 && text2 in COLOR_MAP) return text2;
      }
      // 2. Fallback: checked Color radio input anywhere on the page
      var colorRadio = document.querySelector('input[name="Color"]:checked');
      if (colorRadio && colorRadio.value in COLOR_MAP) return colorRadio.value;
      // 3. Fallback: any checked radio with a color value
      var allChecked = document.querySelectorAll('.js-variant-radio-item:checked, .js-variant-item:checked');
      for (var i = 0; i < allChecked.length; i++) {
        if (allChecked[i].value in COLOR_MAP) return allChecked[i].value;
      }
      return 'Yellow Gold';
    }

    function updateAllSwatchImages(color) {
      var colorKey = COLOR_MAP[color];
      if (!colorKey) return;

      var imgWraps = container.querySelectorAll('[data-finish-img]');
      imgWraps.forEach(function(wrap) {
        var finish = wrap.dataset.finishImg; // e.g. "Hammered"
        var url = getImageUrl(finish, colorKey);
        if (!url) return;

        var img = wrap.querySelector('.finish-block__option-img');
        if (img) {
          // Must clear srcset — Shopify's image_tag generates srcset
          // and browsers prioritize srcset over src
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = url;
          img.alt = finish + ' finish - ' + color;
        } else {
          // Replace placeholder with image
          var placeholder = wrap.querySelector('.finish-block__option-placeholder');
          if (placeholder) placeholder.remove();
          var newImg = document.createElement('img');
          newImg.src = url;
          newImg.alt = finish + ' finish - ' + color;
          newImg.className = 'finish-block__option-img';
          newImg.loading = 'lazy';
          wrap.appendChild(newImg);
        }
      });
    }

    // ============================================================
    // UTILITY FUNCTIONS
    // ============================================================

    function upsertHiddenProperty(name, value) {
      var inputName = 'properties[' + name + ']';
      var input = null;
      var inputs = productForm.querySelectorAll('input[type="hidden"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].name === inputName) {
          input = inputs[i];
          break;
        }
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        productForm.appendChild(input);
      }
      input.value = value;
    }

    function removeHiddenProperty(name) {
      var inputName = 'properties[' + name + ']';
      var inputs = productForm.querySelectorAll('input[type="hidden"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].name === inputName) {
          inputs[i].remove();
          break;
        }
      }
    }

    function clearAllFinishProperties() {
      removeHiddenProperty('Finish');
      removeHiddenProperty('Finish Fee');
    }

    function getOrInitState() {
      if (!window._productFeeState) window._productFeeState = {};
      var productId = productForm.id || 'default';
      if (!window._productFeeState[productId]) {
        var priceSpan = findPriceSpan(priceContainer);
        var originalPrice = 0;
        if (priceSpan) {
          if (priceSpan.dataset.originalPrice) {
            originalPrice = parseFloat(priceSpan.dataset.originalPrice);
          } else {
            var priceText = priceSpan.textContent.replace(/[^0-9.]/g, '');
            originalPrice = parseFloat(priceText) || 0;
            priceSpan.dataset.originalPrice = originalPrice.toString();
          }
        }
        window._productFeeState[productId] = {
          originalPrice: originalPrice,
          quarterSizeFee: 0,
          engravingFee: 0,
          customFinishFee: 0
        };
      }
      return window._productFeeState[productId];
    }

    function updateDisplayedPrice(addAmount) {
      if (!priceContainer) return;

      var priceSpan = findPriceSpan(priceContainer);
      if (!priceSpan) return;

      var state = getOrInitState();
      state.customFinishFee = addAmount / 100;

      var newPrice = state.originalPrice + state.quarterSizeFee + state.engravingFee + state.customFinishFee;
      var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      priceSpan.textContent = formatter.format(newPrice);

      var productId = productForm.id || 'default';
      document.dispatchEvent(new CustomEvent('customFinishFeeChanged', {
        detail: { productId: productId, customFinishFee: state.customFinishFee }
      }));
    }

    function resetDisplayedPrice() {
      if (!priceContainer) return;

      var priceSpan = findPriceSpan(priceContainer);
      if (!priceSpan) return;

      var productId = productForm.id || 'default';

      if (window._productFeeState && window._productFeeState[productId]) {
        var state = window._productFeeState[productId];
        state.customFinishFee = 0;

        var newPrice = state.originalPrice + state.quarterSizeFee + state.engravingFee;
        var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        priceSpan.textContent = formatter.format(newPrice);

        document.dispatchEvent(new CustomEvent('customFinishFeeChanged', {
          detail: { productId: productId, customFinishFee: 0 }
        }));
      }
    }

    function showFeeNotice(finishName) {
      if (!finishName || FEE_CENTS === 0) {
        feeNotice.hidden = true;
        return;
      }
      feeNotice.hidden = false;
      feeText.textContent = finishName + ' finish includes a ';
      feeAmountEl.textContent = FEE_FORMATTED;
    }

    // ============================================================
    // EVENT HANDLERS
    // ============================================================

    function handleFinishChange(e) {
      currentFinish = e.target.value;

      if (currentFinish === 'Polished') {
        // Polished is the standard/default finish - no fee
        selectedFinishDisplay.textContent = 'Polished';
        showFeeNotice(null);
        upsertHiddenProperty('Finish', 'Polished');
        removeHiddenProperty('Finish Fee');
        if (FEE_CENTS > 0) {
          resetDisplayedPrice();
        }
      } else if (currentFinish) {
        selectedFinishDisplay.textContent = currentFinish;
        showFeeNotice(currentFinish);
        upsertHiddenProperty('Finish', currentFinish);
        if (FEE_CENTS > 0) {
          upsertHiddenProperty('Finish Fee', FEE_FORMATTED);
          updateDisplayedPrice(FEE_CENTS);
        }
      }
    }

    function handleFormSubmit(e) {
      // Polished is always selected (default), so always set Finish property
      upsertHiddenProperty('Finish', currentFinish);
      if (currentFinish !== 'Polished' && FEE_CENTS > 0) {
        upsertHiddenProperty('Finish Fee', FEE_FORMATTED);
      } else {
        removeHiddenProperty('Finish Fee');
      }
    }

    // ============================================================
    // BIND EVENTS
    // ============================================================

    radios.forEach(function(radio) {
      radio.addEventListener('change', handleFinishChange);
    });

    productForm.addEventListener('submit', handleFormSubmit, true);

    // Add to Cart fee handler
    var addToCartBtn = productForm.querySelector('[type="submit"], button[name="add"], .product-form__submit');
    if (addToCartBtn && FEE_VARIANT_ID) {
      addToCartBtn.addEventListener('click', function() {
        // Only add fee for non-Polished finishes
        if (!currentFinish || currentFinish === 'Polished') return;
        if (FEE_CENTS === 0) return;

        var mainVariantInput = productForm.querySelector('input[name="id"]');
        var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
        if (!mainVariantId) return;

        setTimeout(async function() {
          try {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: parseInt(FEE_VARIANT_ID, 10),
                  quantity: 1,
                  properties: {
                    'Fee for': 'Finish',
                    'Finish type': currentFinish,
                    'Main variant id': String(mainVariantId)
                  }
                }]
              })
            });

            if (response.ok) {
              var cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
              if (cartDrawerForm && typeof cartDrawerForm.getSectionsToRender === 'function') {
                var sections = cartDrawerForm.getSectionsToRender();
                var sectionIds = sections.map(function(s) { return s.section || s.id; }).filter(Boolean);
                if (sectionIds.length) {
                  var refreshResponse = await fetch('/?sections=' + sectionIds.join(','));
                  var refreshedSections = await refreshResponse.json();
                  if (typeof cartDrawerForm.renderContents === 'function') {
                    cartDrawerForm.renderContents({ sections: refreshedSections });
                  }
                }
              }
              document.dispatchEvent(new Event('cart:refresh'));
            }
          } catch (err) {
            // Silent fail for fee addition
          }
        }, 1500);
      });
    }

    // ============================================================
    // COLOR VARIANT CHANGE LISTENER
    // Primary: MutationObserver on the Color label text element
    //   (.js-variant-radio-option-name[data-option-name="Color"])
    //   This element is always updated by the variant picker when
    //   the color changes — it's the most reliable signal.
    // Fallback: click listeners on color swatch radios + global change
    // ============================================================
    function onColorChange() {
      var newColor = getSelectedColor();
      if (newColor && newColor !== currentColor) {
        currentColor = newColor;
        updateAllSwatchImages(currentColor);
      }
    }

    // PRIMARY: MutationObserver on the Color option name display
    // The variant picker always updates this span's textContent
    var colorNameDisplay = document.querySelector('.js-variant-radio-option-name[data-option-name="Color"]');
    if (colorNameDisplay) {
      var colorObserver = new MutationObserver(function() {
        var displayedColor = colorNameDisplay.textContent.trim();
        if (displayedColor && displayedColor in COLOR_MAP && displayedColor !== currentColor) {
          currentColor = displayedColor;
          updateAllSwatchImages(currentColor);
        }
      });
      colorObserver.observe(colorNameDisplay, { childList: true, characterData: true, subtree: true });
    }

    // Also try the dropdown variant name display
    var colorSelectDisplay = document.querySelector('.js-variant-select-option-name[data-option-name="Color"]');
    if (colorSelectDisplay && colorSelectDisplay !== colorNameDisplay) {
      var colorSelectObserver = new MutationObserver(function() {
        var displayedColor = colorSelectDisplay.textContent.trim();
        if (displayedColor && displayedColor in COLOR_MAP && displayedColor !== currentColor) {
          currentColor = displayedColor;
          updateAllSwatchImages(currentColor);
        }
      });
      colorSelectObserver.observe(colorSelectDisplay, { childList: true, characterData: true, subtree: true });
    }

    // FALLBACK: Direct click listeners on Color radio inputs
    var colorRadios = document.querySelectorAll('input[name="Color"].js-variant-radio-item, input[name="Color"].js-variant-item');
    colorRadios.forEach(function(radio) {
      radio.addEventListener('click', function() {
        // Small delay to let the variant picker process the click
        setTimeout(function() {
          var clickedValue = radio.value;
          if (clickedValue in COLOR_MAP && clickedValue !== currentColor) {
            currentColor = clickedValue;
            updateAllSwatchImages(currentColor);
          }
        }, 100);
      });
    });

    // FALLBACK: Global change on radio/select
    document.addEventListener('change', function(e) {
      if (e.target.name === 'Color') {
        setTimeout(function() {
          onColorChange();
        }, 100);
      }
    });

    // ============================================================
    // VARIANT CHANGE: Listen for variant ID input change
    // The theme dispatches change on input[name="id"] when variant changes.
    // We reset originalPrice and re-apply fees.
    // ============================================================
    var variantInput = productForm.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', function() {
        var productId = productForm.id || 'default';
        // Delete cached state so originalPrice is re-read from new variant price
        if (window._productFeeState) {
          delete window._productFeeState[productId];
        }
        onColorChange();
        // Wait for theme to finish rendering the new price
        if (currentFinish && currentFinish !== 'Polished' && FEE_CENTS > 0) {
          setTimeout(function() { updateDisplayedPrice(FEE_CENTS); }, 300);
        }
      });
    }

    // Listen for engraving fee changes to stay in sync
    document.addEventListener('engravingFeeChanged', function(e) {
      var productId = productForm.id || 'default';
      if (e.detail.productId === productId && window._productFeeState && window._productFeeState[productId]) {
        window._productFeeState[productId].engravingFee = e.detail.engravingFee || 0;
        if (currentFinish && currentFinish !== 'Polished' && FEE_CENTS > 0) {
          updateDisplayedPrice(FEE_CENTS);
        }
      }
    });

    // ============================================================
    // INIT: Set initial color and update images
    // ============================================================
    currentColor = getSelectedColor();
    updateAllSwatchImages(currentColor);

    // Set initial Finish property (Polished is default)
    upsertHiddenProperty('Finish', 'Polished');
    selectedFinishDisplay.textContent = 'Polished';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFinishBlock);
  } else {
    setTimeout(initFinishBlock, 100);
  }
})();
